import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import _ from 'lodash';
import { EditorState, Modifier } from 'draft-js';
import { useProposalContext } from 'context/proposal';
import './ColorPicker.scss';

const RenderColorPicker = ({ state, onToggle, className, onClose }) => {
  const [color, setColor] = useState('');
  const { updateLastUsedColor, getPresetColors } = useProposalContext();

  const TABS = [
    {
      style: 'COLOR',
      text: 'Text',
    },
    {
      style: 'BACKGROUND',
      text: 'Highlight',
    },
  ];

  useEffect(() => {
    try {
      if (color !== '') {
        return;
      }
      const { editorState } = state;
      const currentStyle = editorState.getCurrentInlineStyle();
      let _color = '';

      if (state.displayColorPicker === 'COLOR') {
        _color =
          currentStyle.filter((value) => value?.toString()?.startsWith('rgba')).last() || '#4a4a4a';
      } else {
        _color =
          currentStyle.filter((value) => value?.toString()?.startsWith('bg-')).last() ||
          'rgba(255,255,255,1)';
        if (color?.startsWith('bg-')) {
          _color = _color.substring(3);
        }
      }

      setColor(_color);
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const clearInlineColorStyles = (es, type) => {
    const selection = es.getSelection();
    const contentState = es.getCurrentContent();
    const styles = [];
    // regex for COLOR = rgba should not have bg- infront of rgba
    // regex for BACKGROUND = it will match bg-rgba
    const testPattern = type === 'COLOR' ? /^(?!.*\bbg-.*\brgba\b).*\brgba\b/m : /\b(bg-rgba)\b/m;

    if (selection.isCollapsed()) {
      es.getCurrentInlineStyle().forEach(
        (style) => style && testPattern.test(style) && styles.push(style)
      );
    } else {
      let key = selection.getStartKey();
      let startOffset = selection.getStartOffset();
      const endKey = selection.getEndKey();
      const endOffset = selection.getEndOffset();

      while (true) {
        const lastRound = key === endKey;
        const block = contentState.getBlockForKey(key);
        const offsetEnd = lastRound ? endOffset : block.getLength();
        const characterList = block?.getCharacterList();
        for (let offsetIndex = startOffset; offsetIndex < offsetEnd; offsetIndex++)
          characterList
            .get(offsetIndex)
            .getStyle()
            .forEach((style) => style && testPattern.test(style) && styles.push(style));
        if (lastRound) break;
        key = contentState.getKeyAfter(key);
        startOffset = 0;
      }
    }

    const contentWithoutStyles = _.reduce(
      styles,
      (newContentState, style) =>
        Modifier.removeInlineStyle(newContentState, es.getSelection(), style),
      es.getCurrentContent()
    );
    return EditorState.push(es, contentWithoutStyles, 'change-inline-style');
  };

  const toggleColor = (toggledColor, type) => {
    try {
      const { editorState } = state;
      const currentEditorState = clearInlineColorStyles(editorState, type);
      let selectedColor = '';

      if (toggledColor) {
        if (typeof toggledColor === 'string') {
          selectedColor = toggledColor;
        } else {
          selectedColor = `rgba(${toggledColor.rgb.r}, ${toggledColor.rgb.g}, ${toggledColor.rgb.b}, ${toggledColor.rgb.a})`;
        }
      } else {
        const currentStyle = editorState.getCurrentInlineStyle();
        if (type === 'COLOR') {
          // for text color
          selectedColor =
            currentStyle.filter((value) => value?.toString()?.startsWith('rgba')).last() ||
            '#4a4a4a';
        } else {
          // for background
          selectedColor =
            currentStyle.filter((value) => value?.toString()?.startsWith('bg-')).last() ||
            'rgba(255,255,255,1)';
        }
      }

      if (type === 'BACKGROUND' && !selectedColor.startsWith('bg-')) {
        selectedColor = `bg-${selectedColor}`;
      }

      onToggle({
        es: currentEditorState,
        inlineStyle: selectedColor,
      });
    } catch (error) {}
  };

  return (
    <div className={`color-picker ${className}`}>
      <div className="mask" onClick={onClose} />
      <div className="wrapper" onClick={(e) => e.stopPropagation()}>
        <div className="color-tabs">
          {TABS.map((tab) => (
            <div
              key={tab.text}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onToggle({ inlineStyle: tab.style });
              }}
              className={`color-tab ${state.displayColorPicker === tab.style ? 'active' : ''}`}>
              {tab.text}
            </div>
          ))}
        </div>
        <div onMouseDown={(e) => e.stopPropagation()}>
          <SketchPicker
            color={color}
            onChange={(toggledColor, e) => {
              e.stopPropagation();
              const _color = `rgba(${toggledColor.rgb.r}, ${toggledColor.rgb.g}, ${toggledColor.rgb.b}, ${toggledColor.rgb.a})`;

              setColor(_color);
              updateLastUsedColor(_color);
              toggleColor(_color, state.displayColorPicker);
            }}
            presetColors={getPresetColors()}
          />
        </div>
      </div>
    </div>
  );
};

export default RenderColorPicker;
